import styled from 'styled-components'

import { ClinTheme } from '../../ClinTheme'
import { ClinText } from '../../components/ClinText'

interface StatusPillProps {
  status?: string | null
}

export const StyledProgramContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: ClinTheme.space[2]
})

export const StyledProgramRowItem = styled.div({
  backgroundColor: ClinTheme.colors.white,
  padding: '8px 16px',
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
  '&:hover': {
    boxShadow: `0px 0px 6px 0px ${ClinTheme.colors.grey}`
  }
})

export const StyledProgramItemContentLeft = styled.div({
  display: 'flex',
  flexDirection: 'column'
})

export const StyledProgramPillButton = styled.div<StatusPillProps>(
  ({ status }) => {
    const normalizedStatus = status?.toLowerCase?.() || ''

    let backgroundColor
    let color

    switch (normalizedStatus) {
      case 'accepting new patients':
        backgroundColor = ClinTheme.colors.lightenGreen
        color = ClinTheme.colors.deepGreen
        break

      case 'resupply only':
        backgroundColor = ClinTheme.colors.deliveryDateBackground
        color = ClinTheme.colors.primaryMid
        break

      case 'open for resupply':
      case 'register your interest':
        backgroundColor = '#FBF0E5'
        color = ClinTheme.colors.black
        break

      case 'closed':
        backgroundColor = ClinTheme.colors.lightGrey
        color = ClinTheme.colors.black
        break

      default:
        backgroundColor = '#F5F5F5'
        color = ClinTheme.colors.black
    }

    return {
      backgroundColor,
      padding: '4px 15px',
      borderRadius: ClinTheme.radii[2],
      color,
      marginRight: '32px',
      fontSize: '12px',
      fontWeight: ClinTheme.fontWeights.medium,
      lineHeight: '16px',
      minWidth: '152px',
      textAlign: 'center',
      textTransform: 'none'
    }
  }
)

export const StyledProgramItemContentRight = styled.div({
  display: 'flex',
  alignItems: 'center',
  marginLeft: 'auto'
})

export const StyledProgramEnrolled = styled.div({
  backgroundColor: '#E5F6E9',
  color: '#006716',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '13px',
  width: '53px',
  fontSize: '10px',
  height: '16px',
  display: 'flex',
  margin: '4px 12px',
  fontWeight: ClinTheme.fontWeights.medium
})

export const StyledProgramBrandText = styled(ClinText)({
  width: '100%',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  maxWidth: '790px',
  textOverflow: 'ellipsis',
  margin: 0,
  lineHeight: '24px',
  color: ClinTheme.colors.darkGrey,
  fontSize: ClinTheme.fontSizes[1],
  [`@media screen and (max-width: ${ClinTheme.breakpoints[2]}px)`]: {
    whiteSpace: 'normal'
  }
})
